/**
 * 화면 브랜딩(로고·서비스명·파비콘·푸터·약관)을 결정하는 호스트를 돌려준다.
 *
 * 로컬 개발에서는 실제 호스트가 localhost 라서 어느 사이트로도 보이지 않는다.
 * 그래서 localhost 에서만 로그인 화면에서 고른 호스트를 대신 쓸 수 있게 한다.
 *
 * 주의: 이 값은 "보이는 것"에만 쓴다.
 * API 주소·소켓·PG 결제주소·마켓 노출 권한 등 동작에 관계된 것은
 * 반드시 실제 window.location.hostname 을 그대로 써야 한다.
 */

const STORAGE_KEY = '__themeHost';

/** 로그인 화면 셀렉트에 보여줄 목록. value 가 실제 호스트명이다. */
export const THEME_HOST_OPTIONS = [
  { value: '', name: '기본 (localhost)' },
  { value: 'omarket.kr', name: '셀리오마켓 (omarket.kr)' },
  { value: 'overlink.kr', name: '오버링크 (overlink.kr)' },
  { value: 'cospia.net', name: '오손업로드 (cospia.net)' },
  { value: 'magicone.kr', name: '매직원 (magicone.kr)' },
  { value: 'smartcross.kr', name: '스마트크로스 (smartcross.kr)' },
  { value: 'crosssell.co.kr', name: '크로스셀 (crosssell.co.kr)' },
  { value: 'daenlabs.kr', name: '다엔랩스 (daenlabs.kr)' },
  { value: 'kimmanager.co.kr', name: '김매니저 (kimmanager.co.kr)' },
  { value: 'connectone07.co.kr', name: '커넥트원 (connectone07.co.kr)' },
  { value: 'kcode.store', name: '케이코드 (kcode.store)' },
  { value: 'zijyasssssell.com', name: '지쟈쓰 (zijyasssssell.com)' },
  { value: 'stock.overlink.kr', name: '재고관리 (stock.overlink.kr)' }
];

/** 개발 환경(로컬)에서만 테마를 바꿔 볼 수 있다. 운영 도메인에서는 절대 적용되지 않는다. */
export function isLocalTheme() {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1' || host === '[::1]';
}

export function getThemeHostOverride() {
  if (!isLocalTheme()) return '';
  try {
    return localStorage.getItem(STORAGE_KEY) || '';
  } catch (e) {
    return '';
  }
}

export function setThemeHostOverride(host) {
  try {
    if (host) localStorage.setItem(STORAGE_KEY, host);
    else localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    /* 사파리 프라이빗 모드 등에서 저장이 막혀도 화면은 계속 동작해야 한다 */
  }
}

/**
 * 브랜딩 판단에 쓸 호스트명.
 * 운영에서는 언제나 실제 호스트, 로컬에서는 선택한 호스트(없으면 localhost).
 */
export function getThemeHost() {
  if (typeof window === 'undefined') return '';
  return getThemeHostOverride() || window.location.hostname;
}
